import { PropsWithChildren } from 'react';
import { AnyComparator } from 'modules/queryBuilder/types';
import { QueryBuilderSelect } from 'ui/queryBuilder/Selects';
import { ConditionSingleValueSelectProps } from 'ui/queryBuilder/types';
import { useCustomComparatorOptions, useTrackMatchesCatalogSelection } from './hooks';

export const CustomConditionComparatorSelect = ({
  options = [],
  value,
  fieldType,
  ...props
}: PropsWithChildren<ConditionSingleValueSelectProps<AnyComparator>>) => {
  const customComparatorOptions = useCustomComparatorOptions(options, value, fieldType);
  /** sets matches catalog selection if current value is MatchesCatalogData */
  useTrackMatchesCatalogSelection(value);
  const queryBuilderSelectProps = {
    ...props,
    value,
    options: customComparatorOptions,
  };
  return <QueryBuilderSelect {...queryBuilderSelectProps} />;
};
